/*
*
* File JS per la pagina singola soluzioni
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import applicationSolutions from '../../components/application-solutions/application-solutions.js';
import faq from '../../components/faq/faq.js';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './soluzioni-single.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{
    applicationSolutions();
    faq();

    // Hero Solution Video custom player
    document.querySelectorAll('[data-hero-video]').forEach((wrapper) =>
    {
        const video = wrapper.querySelector('video');
        const button = wrapper.querySelector('.hero-solution__media-video-play');
        const controls = wrapper.querySelector('.hero-solution__media-video-controls');
        const seek = wrapper.querySelector('.hero-solution__media-video-seek');

        // il blocco assume le proporzioni reali del video (poster in cover)
        const setRatio = () =>
        {
            if (video.videoWidth && video.videoHeight) {
                wrapper.style.aspectRatio = video.videoWidth + ' / ' + video.videoHeight;
            }
        };
        video.readyState >= 1 ? setRatio() : video.addEventListener('loadedmetadata', setRatio);

        const toggle = () => (video.paused ? video.play() : video.pause());

        wrapper.addEventListener('click', toggle);
        button.addEventListener('click', (e) =>
        {
            e.stopPropagation();
            toggle();
        });

        // i click sulla barra comandi non devono fare play/pausa
        controls.addEventListener('click', (e) => e.stopPropagation());
        controls.querySelectorAll('[data-action]').forEach((btn) =>
        {
            btn.addEventListener('click', () =>
            {
                const action = btn.dataset.action;
                if (action === 'toggle') {
                    toggle();
                } else if (action === 'mute') {
                    video.muted = !video.muted;
                } else if (action === 'fullscreen') {
                    document.fullscreenElement
                        ? document.exitFullscreen()
                        : (wrapper.requestFullscreen || wrapper.webkitRequestFullscreen || (() => video.webkitEnterFullscreen && video.webkitEnterFullscreen())).call(wrapper);
                }
            });
        });

        video.addEventListener('play', () =>
        {
            wrapper.classList.add('is-started', 'is-playing');
            wrapper.classList.remove('is-paused');
        });
        video.addEventListener('pause', () =>
        {
            wrapper.classList.remove('is-playing');
            wrapper.classList.add('is-paused');
        });
        // a fine video si torna allo stato iniziale: poster e play centrale
        video.addEventListener('ended', () =>
        {
            wrapper.classList.remove('is-started', 'is-playing', 'is-paused');
            seek.value = 0;
            seek.style.setProperty('--progress', '0%');
            video.load();
        });
        video.addEventListener('volumechange', () => wrapper.classList.toggle('is-muted', video.muted));
        video.addEventListener('timeupdate', () =>
        {
            const value = video.duration ? video.currentTime / video.duration * 100 : 0;
            seek.value = value;
            seek.style.setProperty('--progress', value + '%');
        });
        seek.addEventListener('input', () =>
        {
            if (video.duration) {
                video.currentTime = seek.value / 100 * video.duration;
            }
        });
    });

    // Init Swiper Hero Solution Gallery
    const heroSolutionSwiper = document.querySelector('.hero-solution-swiper');
    
    if (heroSolutionSwiper) {
        new Swiper('.hero-solution-swiper', {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
});

//--------------------------------------------------------------------//